// extracted by mini-css-extract-plugin
export var numpadContainer = "_n4-1";
export var phoneButton = "_n4-0";